module.exports = __webpack_public_path__ + "static/media/LibudaLogo_komplett_weiß.0fd1ebc0.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/LibudaLogo_komplett_weiß.svg
// module id = 932
// module chunks = 0